import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import getCoreUIStore from "../core/core-ui-store";
import getCorePopUpStore from "../core/core-popup-store";
import {
  isDefinedArray,
  isDefinedString,
  isPositiveNumber
} from "et3-type-guards";
import getKhattabatMatchingStore from "./matching-store";
import { apiCallCreateOneOOneM } from "../../api/khattbat-api/api-call-create-one-o-one-m";

class Khattabat101MStore {
  isMatchesIdsSelectedAll = observable.box<boolean>(false);
  messageToSendToCreated101M = observable.box<string>("");

  setMessageToSendToCreated101M = (message: string) => {
    runInAction(() => {
      this.messageToSendToCreated101M.set(message.trim());
    });
  };

  toggleIsMatchesIdsSelectedAll = () => {
    const currentState = this.isMatchesIdsSelectedAll.get();
    runInAction(() => {
      this.isMatchesIdsSelectedAll.set(!currentState);
    });
  };

  resetSelectAll = () => {
    runInAction(() => {
      this.isMatchesIdsSelectedAll.set(false);
    });
  };

  canOpenOneOOneMConversations = computed(() => {
    return (
      isPositiveNumber(
        getKhattabatMatchingStore().currentClientInformation.get().userId
      ) &&
      isDefinedArray(getKhattabatMatchingStore().matchesIds.get()) &&
      isDefinedString(this.messageToSendToCreated101M.get()) &&
      this.isMatchesIdsSelectedAll.get()
    );
  });

  openOneOOneMConversations = async () => {
    const clientID =
      getKhattabatMatchingStore().currentClientInformation.get().userId;
    const matchIDs = getKhattabatMatchingStore().matchesIds.get();
    const message = this.messageToSendToCreated101M.get();

    getCoreUIStore().setIsLoading("KHATTABAT_MATCHING_SEARCH_AND_1O1M", true);
    try {
      const { status, code, data } = await apiCallCreateOneOOneM({
        clientID,
        matchIDs,
        message
      });

      if (status === "OK") {
        const parsedData = data
          .map(({ matchID, status }) => `${matchID}_${status}`)
          .join("\n");
        getCorePopUpStore().showSuccessMessageWithExtraData(
          "ONE_O_ONE_M_SENT_RESULT",
          parsedData,
          true
        );
        getKhattabat101MStore().toggleIsMatchesIdsSelectedAll();
        getKhattabatMatchingStore().resetFilter();
      } else {
        getCorePopUpStore().showAlertMessage(code);
      }
    } catch (error) {
      getCorePopUpStore().showAlertMessage(error);
      return error;
    } finally {
      getCoreUIStore().setIsLoading(
        "KHATTABAT_MATCHING_SEARCH_AND_1O1M",
        false
      );
    }
  };
}

export const getKhattabat101MStore = memoize(
  () => new Khattabat101MStore(),
  () => 1
);
export default getKhattabat101MStore;
